import { UserRole } from "tm-shared/types";

import { isManagerRole } from "@/utils/business/isManagerRole";

const ACCESS_ROLE_MAP: Partial<Record<UserRole, UserRole>> = {
    [UserRole.Ta]: UserRole.Ta,
    [UserRole.Sv]: UserRole.Ta,
    [UserRole.Md]: UserRole.Md,
    [UserRole.Svm]: UserRole.Md,
};

export interface InfoTabCapabilities {
    canSeePlanLink: boolean;
}

export interface TasksTabCapabilities {
    taskAccessRole: UserRole | null;
    canCreateTask: boolean;
}

export interface AboutPointCapabilities {
    canSeeHistoryTab: boolean;
    canSeeDebtTab: boolean;
    canSeeAddressVerifyAlert: boolean;
    canFetchUnassignedPlan: boolean;
    infoTab: InfoTabCapabilities;
    tasksTab: TasksTabCapabilities;
}

export const getAboutPointCapabilities = (
    role: UserRole,
): AboutPointCapabilities => ({
    canSeeHistoryTab: role === UserRole.Ta || role === UserRole.Sv,
    canSeeDebtTab: role === UserRole.Ta || role === UserRole.Sv,
    canSeeAddressVerifyAlert: role === UserRole.Sv || role === UserRole.Svm,
    canFetchUnassignedPlan: role === UserRole.Sv,
    infoTab: {
        canSeePlanLink: role !== UserRole.Svm && role !== UserRole.Md,
    },
    tasksTab: {
        taskAccessRole: ACCESS_ROLE_MAP[role] ?? null,
        canCreateTask: Boolean(isManagerRole(role)),
    },
});
